module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('h1', [_vm._v("Saindo...")]), _vm._v(" "), _c('small', [_vm._v("Obrigado!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf8a6cf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginLogout/Logout.vue
// module id = 1022
// module chunks = 1